<script setup lang="ts">
import BaseButton from '@/components/ui/button/BaseButton.vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'

defineProps({
	content: {
		type: Object,
		required: true,
	},
})

const icons = ['plane_v3', 'community_v3', 'online_store_v3']

const handleCardClick = (index: number) => {
	const ITEMS = ['More About Shipping', 'More About Shopping', 'Browse Deals']

	createGAEvent(GaGeneralEvent.ButtonClick, {
		page_name: GaGeneralPageName.HomePage,
		button_name: ITEMS[index],
	})
}
</script>

<template>
	<div class="bs-container py-distant-acquaintances">
		<div class="col-span-12">
			<div
				class="mb-acquaintances flex flex-col items-center gap-close-friends text-center"
			>
				<div
					class="typography-h2-str text-n-950 [&>span]:text-o-500"
					v-html="content.title"
				></div>

				<div class="typography-b2-reg text-n-800">
					{{ content.description }}
				</div>
			</div>

			<div class="flex flex-col gap-20px mdp:flex-row lg:gap-24px">
				<div
					v-for="(item, index) in content.cards"
					:key="index"
					class="flex flex-1 flex-col gap-20px rounded-[12px] bg-o-50 p-20px mdp:gap-24px lg:p-24px"
				>
					<div class="flex items-center gap-12px">
						<BaseIcon :name="icons[index]" class="h-32px w-32px fill-o-500" />
						<div class="typography-h4-str text-n-950">
							{{ item.title }}
						</div>
					</div>

					<div class="flex flex-col gap-16px">
						<div
							v-for="(point, index) in item.pointItems"
							:key="index"
							class="flex gap-12px"
						>
							<BaseIcon name="success_v3" class="h-24px w-20px flex-shrink-0" />
							<div class="typography-s1-reg text-n-500">
								{{ point }}
							</div>
						</div>
					</div>

					<a
						:href="item.buttonLink"
						class="mt-auto"
						@click="handleCardClick(index)"
					>
						<BaseButton size="medium" class="w-full">
							{{ item.buttonText }}
						</BaseButton>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>
